import InternalTicketsTables from './InternalTicketsTables';

export { InternalTicketsTables };
export default InternalTicketsTables;
